import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const EcomSettings = lazy(() => import('../components'))

const EcomSettingsRoute: RouteObject = {
  path: 'settings/modules/ecommerce',
  element: <EcomSettings />,
}

export default EcomSettingsRoute
